/**
 * 新增 or 编辑
 */
import React, { useState, useEffect } from 'react'
import {SCommonDialog, SFuncModal} from 'shj-components'
import '../../../index.less'
import { Form, Button, Select, Row, Col, message, Input, Spin, Modal, Upload } from 'antd'
import { layoutInfoSelectById, layoutInfoIOU } from '@/services/customerServices'
import { requestHelper, baseURL } from '@/api'
import UploadImg from '@/components/Upload/ImageUpload'
import { get, uniqueId } from 'lodash-es'
import { useFileUrlPrefix } from 'shj-utils'

const { Option } = Select

const formItemLayout: any = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 3 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 20 },
  },
}

export function modalAddOrEditFn({ fn, ...rest }) {
  const onClose = () => {
    dialog.destroy()
  }

  const dialog = SFuncModal({
    title: `${rest?.id ? '编辑' : '新增'}`,
    width: 900,
    vanish: true,
    content: <ModalAddOrEditDom onClose={onClose} fn={fn} {...rest} />,
  })

  return dialog
}

const ModalAddOrEditDom = ({ onClose, fn, ...rest }) => {
  const [form] = Form.useForm()
  const [submitLoading, setSubmitLoading] = useState<boolean>(false)
  const [allloading, setAllloading] = useState<boolean>(false)
  const [houseImageUrlList, setHouseImageUrlList] = useState<Array>([])
  const [previewImage, setPreviewImage] = useState<string>('')
  const [previewVisible, setPreviewVisible] = useState<boolean>(false)
  const selectObj = {
    towardsList: ['东', '南', '西', '北', '南北', '东西', '东南', '西南', '东北', '西北'],
  }
  const { setFieldsValue } = form
  const { id, buildingId } = rest

  console.log(buildingId, 'buildingId')

  const [imagePrefix] = useFileUrlPrefix()

  useEffect(() => {
    initFn()
  }, [imagePrefix])
  const initFn = () => {
    if (id) {
      getByIdInfo(id).then((res: any) => {
        const newObj = { ...res }
        if (newObj.houseImageUrl) {
          const urlObj = { uid: uniqueId(), url: newObj.houseImageUrl }
          setHouseImageUrlList([urlObj])
          newObj.houseImageUrl = urlObj
        }

        setFieldsValue({ ...newObj })
        setAllloading(false)
      })
    }
  }
  // 根据id查询详情
  const getByIdInfo = (id_: string | number) => {
    setAllloading(true)
    return layoutInfoSelectById(id_)
      .then((resp: any) => {
        return resp || {}
      })
      .catch(() => {
        setAllloading(false)
      })
  }
  // 提交
  const onFinish = (values: any) => {
    form.validateFields().then(values => {
      const newValues = { ...values, houseImageUrl: houseImageUrlList[0]?.url  }
      newValues.id = id || ''
      newValues.buildingId = buildingId
      setSubmitLoading(true)
      const url = id ? '/updateById' : ''
      layoutInfoIOU(newValues, url)
          .then((resp: any) => {
            setSubmitLoading(false)
            message.success(resp?.message || '操作成功')
            onClose()
            fn && fn()
          })
          .catch(() => {
            setSubmitLoading(false)
          })
    })
  }
  const numArr = (startNum: number, numLen: number, name: string) => {
    const arr_ = []
    for (let i = startNum; i <= numLen; i++) {
      arr_.push(
        <Option key={i} value={i}>
          {i}
          {name}
        </Option>
      )
    }
    return arr_
  }
  // 判断文件类型
  const beforeUpload = (file: any) => {
    const isJpgOrPng =
      file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
    if (!isJpgOrPng) {
      message.error('仅支持上传图片格式：jpg/jpeg/png')
    }
    return isJpgOrPng
  }
  const changeUploadImg = (fileList: any) => {
    setHouseImageUrlList(fileList)
    form.setFieldsValue({
      houseImageUrl: fileList.map((eve: any) => get(eve, 'response.data.relativePath'))[0],
    })
  }
  // 图片预览
  const onPreview = (file: any) => {
    const { thumbUrl } = file
    setPreviewImage(`${thumbUrl}`)
    setPreviewVisible(true)
  }

  return (
      <SFuncModal.Content
        onCancel={onClose}
        onOk={onFinish}
        confirmLoading={allloading || submitLoading}
      >
      <Form form={form} onFinish={onFinish} {...formItemLayout} autoComplete="off">
        <Form.Item
          label="户型代码"
          name="layoutCode"
          rules={[{ required: true, message: '请输入' }]}
        >
          <Input placeholder="请输入名称" />
        </Form.Item>
        <Form.Item label="房屋户型" required={true} className="redSpan">
          <Row justify="space-between">
            <Col span={4}>
              <Form.Item
                noStyle
                name="layoutRoomCount"
                rules={[{ required: true, message: '请选择' }]}
              >
                <Select placeholder="请选择" allowClear>
                  {numArr(1, 6, '室')}
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item noStyle name="layoutHallCount" rules={[{ required: true, message: '' }]}>
                <Select placeholder="请选择" allowClear>
                  {numArr(0, 6, '厅')}
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                noStyle
                name="layoutKitchenCount"
                rules={[{ required: true, message: '' }]}
              >
                <Select placeholder="请选择" allowClear>
                  {numArr(1, 3, '厨')}
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item noStyle name="layoutToiletCount" rules={[{ required: true, message: '' }]}>
                <Select placeholder="请选择" allowClear>
                  {numArr(1, 6, '卫')}
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                noStyle
                name="layoutBalconyCount"
                rules={[{ required: true, message: '' }]}
              >
                <Select placeholder="请选择" allowClear>
                  {numArr(0, 6, '阳台')}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Form.Item label="朝向" name="towards" rules={[{ required: true, message: '请选择' }]}>
          <Select placeholder="请选择" allowClear>
            {selectObj.towardsList.map((key: any) => (
              <Option key={key} value={key}>
                {key}
              </Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          label="建筑面积"
          name="constructArea"
          rules={[{ required: true, message: '必须填写正确建筑面积', pattern: /^[0-9]\d*$/ }]}
        >
          <Input placeholder="请输入建筑面积" addonAfter="㎡" />
        </Form.Item>
        <Form.Item
          label="套内面积"
          name="innerArea"
          rules={[{ required: true, message: '必须填写正确套内面积', pattern: /^[0-9]\d*$/ }]}
        >
          <Input placeholder="请输入套内面积" addonAfter="㎡" />
        </Form.Item>
        <Form.Item {...formItemLayout} label="户型图" name="houseImageUrl">
          {/* <Upload
            name="houseImageUrl"
            action={`https://saas-gateway.shjmall.cn/file-web/fileStore/upload`}
            headers={{
                      "Authorization": getToken(),
                      'X-Transfer-Inside-Tenant-Id': getXTransferInsideTenantId()
                    }}
            listType="picture-card"
            onChange={info => changeUploadImg(info)}
            fileList={houseImageUrlList}
            beforeUpload={beforeUpload}
            onPreview={file => onPreview(file)}
          >
            {houseImageUrlList && houseImageUrlList.length < 1 && '+ Upload3333'}
          </Upload> */}
          <UploadImg limit={1} onChange={changeUploadImg} fileList={houseImageUrlList} />
        </Form.Item>
      </Form>
      {/*<Modal
        visible={previewVisible}
        footer={null}
        onCancel={() => {
          setPreviewVisible(false)
        }}
        width={650}
      >
        <img alt="example" style={{ width: '100%' }} src={previewImage} />
      </Modal>*/}
      </SFuncModal.Content>
  )
}
